var template = "\n    <div class=\"col-6\">\n        <input type=\"text\" name=\"{{=it.name}}\" class=\"a-inputText -dateInput js-{{=it.name}}\" aria-label=\"{{=it.label}}\">\n    </div>\n";
export default template;